import { NotificationStatusEnum } from '@models/notification.model';

export class DocumentModel {
  accountId: number;
  createdBy: number;
  dateCreated: Date;
  documents: { [key: string]: string }[];
  isDeleted: boolean;
  personId: string;
  status: DocumentStatusEnum;
  id: string;
  type: DocumentTypeEnum;
  birthDate?: string;
  idNumber?: string;
  isAcceptable: boolean;

  static fromJson(json: any): DocumentModel {
    return {
      accountId: json.account_id,
      createdBy: json.created_by,
      dateCreated: json.date_created,
      documents: json.documents,
      isDeleted: json.is_deleted,
      isAcceptable: json.is_acceptable,
      personId: json.person_id,
      status: json.status,
      id: json._id,
      type: json.type
    };
  }
}

export enum DocumentStatusEnum {
  Approved = 'approved',
  Pending = 'pending',
  Declined = 'declined'
}

export enum DocumentTypeEnum {
  Id = 'id',
  AuthenticationPhoto = 'authentication photo',
  UnalteredPhoto = 'unaltered photo'
}

export enum IconsClass {
  CheckCircle = 'task_alt',
  ExclamationCircle = 'error_outline',
  TimesCircle = 'highlight_off',
  History = 'history'
}

export const DOCUMENT_NOTIFICATIONS_STATUS_ICONS = {
  [NotificationStatusEnum.Approved]: {
    icon: IconsClass.CheckCircle,
    color: 'text-success'
  },
  [NotificationStatusEnum.Declined]: {
    icon: IconsClass.ExclamationCircle,
    color: 'text-warn'
  },
  [NotificationStatusEnum.NotVerified]: {
    icon: IconsClass.TimesCircle,
    color: 'text-sort-grey'
  },
  [NotificationStatusEnum.Pending]: {
    icon: IconsClass.History,
    color: 'text-accent'
  },
  [NotificationStatusEnum.Expired]: {
    icon: IconsClass.ExclamationCircle,
    color: 'text-warn'
  }
};

export enum ManualUploadedDocumentEnum {
  IdCard = 'ID_CARD',
  DrivingLicense = 'DRIVING_LICENSE',
  Passport = 'PASSPORT',
  ResidencePermit = 'RESIDENCE_PERMIT'
}
